import { useToPng } from '@hugocxl/react-to-image';
import CloseIcon from '@mui/icons-material/Close';
import { Button,Card,Dialog,DialogActions,DialogContent,DialogTitle,Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoQrCodeOutline,IoQrCodeSharp } from 'react-icons/io5';
import QRCode from "react-qr-code";
import { toast } from 'react-toastify';
import AttToken from '../../../helpers/attToken';
import { trackEventMatomo } from '../../../helpers/matomo';
import { UnidadeType } from '../../../service/Places';
import Unity from '../../../service/Unity';

type props = {
  unity: UnidadeType;
};

const unityController = new Unity();

export default function QrCodeModal({ unity }: props) {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(unity.qrcode || '');

  /* eslint-disable @typescript-eslint/no-unused-vars */
  const [state, convertToPng, ref] = useToPng<HTMLDivElement>({
    onSuccess: data => {
      const a = document.createElement("a");
      a.href = data;
      a.download = "QrCodeComTitulo.png";
      a.click();
    }
  });

  const [_, convertWithout, refWithout] = useToPng<HTMLDivElement>({
    onSuccess: data => {
      const a = document.createElement("a");
      a.href = data;
      a.download = "QrCode.png";
      a.click();
    }
  });


  const { t } = useTranslation('translation');

  const { mutate: addQrCode, isPending: loading } = useMutation({
    mutationKey: ['ADD_QR'],
    mutationFn: async () => {
      try {
        const token = await AttToken();
        if (!token) throw new Error(`${t('Services.ServiceModal.failedToRetrieveToken')}`);
        const promise = toast.promise(async () => {
          const result = await unityController.addQRCode(token, unity.id);
          if (!result) throw new Error(`${t('Services.ServiceModal.failedToCreateQRCode')}`);
          return result;
        }, {
          pending: `${t('Services.ServiceModal.creatingQRCode')}`,
          error: `${t('Services.ServiceModal.failedToCreateQRCode')}`,
          success: `${t('Services.ServiceModal.qrCodeCreatedSuccessfully')}`
        }, { toastId: 'creatingQrCode' });
        return promise;
      } catch (err) {
        throw new Error(`${t('Services.ServiceModal.failedToCreateQRCode')}`);
      }
    },
  });

  return (
    <>
      {unity.qrcode ?
        <Tooltip title={`${t('Services.ServiceModal.viewQRCode')}`}>
          <IconButton
            onClick={() => {
              trackEventMatomo('Modal QR code', 'click', 'button', 'salva');
              setOpen(true);
            }}
            aria-label="QR">
            <IoQrCodeSharp size={25}
            />
          </IconButton>
        </Tooltip>
        : <Tooltip title={`${t('Services.ServiceModal.addQRCode')}`}>
          <IconButton disabled={loading} aria-label="QR" color='secondary'>
            <IoQrCodeOutline
              onClick={async () => {
                trackEventMatomo('Modal QR code', 'click', 'button', 'salva');
                addQrCode();
                setValue(unity.id);
                unity.qrcode = unity.id;
                setOpen(true);
              }}
              size={25} />
          </IconButton>
        </Tooltip>}
      {open && <Card>
        <Dialog
          fullWidth
          maxWidth='sm'
          open={open}
          onClose={() => setOpen(false)}
          scroll={'paper'}
        >
          <DialogTitle>{t('Services.ServiceModal.qrCode')}</DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers={true}>
            <div style={{ padding: '10px', backgroundColor: 'white' }} ref={refWithout}>
              <QRCode
                size={256}
                style={{ height: "auto", maxWidth: "50%", width: "50%" }}
                value={value}
                viewBox={`0 0 256 256`}
              />
            </div>
            <div style={{ margin: '10px' }}>
              <h1>{t('Services.ServiceModal.unitCode')}</h1>
              <h1 style={{ fontWeight: 'bold' }}>{value}</h1>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={convertToPng}>
              {t('Services.ServiceModal.downloadQRCodeWithTitle')}
            </Button>
            <Button onClick={convertWithout}>
              {t('Services.ServiceModal.downloadQRCodeWithoutTitle')}
            </Button>
          </DialogActions>
        </Dialog>
      </Card >}
    </>
  );
}
